// extracted by mini-css-extract-plugin
export default {"coverPhotoSkeleton":"SeriesPageContentsSkeleton_coverPhotoSkeleton__ArqTC"};